export const TITLE = {
	EXCEPTION: "Exception",
	COMMENT: "Comment"
};
